import firebase from 'firebase/app'
import { isNil } from 'lodash'

import store from '@/store'

firebase.auth().onAuthStateChanged(firebaseUser => {
  const actionToDispatch = isNil(firebaseUser) ? 'logout' : 'login'
  // Pass isInitialAuthCheck flag to prevent redirect during initial auth check
  const payload = isNil(firebaseUser)
    ? { isInitialAuthCheck: true }
    : firebaseUser
  store.dispatch(`authentication/${actionToDispatch}`, payload)
})
